import { apiFetch } from '@/lib/api/client';

export interface AuthUser {
  id: string;
  email: string;
  name?: string | null;
}

export interface AuthTenant {
  id: string;
  name: string;
  slug: string;
  role: string;
}

export interface SignupResult {
  access_token: string;
  token_type: string;
  user: AuthUser;
  tenant: AuthTenant;
}

export interface SigninResult {
  access_token: string;
  token_type: string;
  user: AuthUser;
}

export interface SignupInput {
  email: string;
  password: string;
  workspace_name: string;
}

export interface SigninInput {
  email: string;
  password: string;
}

/** Create an account and its first workspace; returns an access token. */
export function signupRequest(input: SignupInput): Promise<SignupResult> {
  return apiFetch<SignupResult>('/auth/signup', { method: 'POST', body: input });
}

/** Authenticate with email + password; returns an access token. */
export function signinRequest(input: SigninInput): Promise<SigninResult> {
  return apiFetch<SigninResult>('/auth/signin', { method: 'POST', body: input });
}

/** End the server session (stateless today; the client also drops its token). */
export function signoutRequest(): Promise<void> {
  return apiFetch<void>('/auth/signout', { method: 'POST' });
}
